import _ from 'lodash';
import { UntypedFormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

export const PasswordValidator: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    const password = control.get('password');
    const passwordValue = _.get(password, 'value', null);

    const repeatPassword = control.get('repeatPassword');
    const repeatPasswordValue = _.get(repeatPassword, 'value', null);

    return _.isEqual(passwordValue, repeatPasswordValue) ? null : { password: true };
};
